import React, { Component } from "react";
import {
  doReviewsubmit,
  doReportFeedback,
  doInviteExternalReviewer,
  doReviewCommit,
  popModal,
  UpdateState,
  getState,
  getSession,
  AlertMessage,
  AlertMessageOut,
  clearSession,
  setSession,
} from "./function";
import ReactPaginate from "react-paginate";
import {
  limit_per_page,
  name,
  ApiEndpoint,
  platform,
  hideRegion,
  feedbackInputLimit,
} from "../Constant";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { DateTime } from "../Components/function";
import FileUnsupported from "../Assets/FileUnsupported.png";
import * as axios from "axios";
import $, { get } from "jquery";

// Initialize an agent at application startup.
const fpPromise = FingerprintJS.load();

export const FingerPrint = async (type = "visitor") => {
  // Get the visitor identifier when you need it.
  const fp = await fpPromise;
  const result = await fp.get();

  // This is the visitor identifier:
  if (type === "visitor") {
    return result.visitorId;
  } else {
    //return result.visitorId;
  }
};

class DataTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      total_page: 1,
      total_result: 0,
      offset: "-1",
      offset_set: 0,
      limit: limit_per_page,
      page_target: "0",
      specific_region: "",
      resolved_id: "",
      firstRender: 0,
      data: [],
      message: "",
      loading: "",
      retry_times: 0,
    };

    this.clearPagingData = this.clearPagingData.bind(this);
    this.updatePageTarget = this.updatePageTarget.bind(this);
    this.updatePageRegionTarget = this.updatePageRegionTarget.bind(this);
  }

  componentDidMount() {
    this.loadDataFromServer(
      this.props.cmd,
      getState(this, "offset"),
      getState(this, "limit")
    );

    var that = this;

    $(function () {
      $(document).on("click", "#report-feedback", function (e) {
        e.preventDefault();
        let $feedbackID = $(document).find(this).data("feedbackid");
        let $scriptID = $(document).find(this).data("scriptid");
        let $feedback = $(document).find(this).data("feedback");
        let $user = $(document).find(this).data("user");
        let $vote = $(document).find(this).data("vote");
        let $vote_class = $(document).find(this).data("voteclass");

        let $feedbackReportPane = "";
        let $feedbackPane = "";

        $feedbackPane +=
          "<div style='margin-bottom: 10px;'><blockquote style='text-align: left; font-size: 16px;width:100%; margin:20px auto; font-family:Open Sans; font-style:italic;  color: #555555; padding:14px; padding-top: 50px; border-radius: 5px; border: 1px solid rgba(213,210,229,.8); line-height:1.6; position: relative; background: #fafafa;'>" +
          $feedback +
          "<br/><span style='display:block;color:#333333;font-style: normal;font-weight: bold; margin-top:17px; font-size: 15px;'><i class='fa fa-user-circle'></i> " +
          $user +
          "</span><span style='position: absolute;top: 0; right: 0; padding: 8px 16px;font-weight: 600;font-size: 12px;box-shadow: 0 2px 5px rgba(0,0,0,.25);margin: 4px 4px 0px 0px; border-radius: 5px;' class='chip vote " +
          $vote_class +
          "'>" +
          $vote +
          "</span>";
        $feedbackPane += "</blockquote></div>";

        $feedbackReportPane +=
          "<div class='greyAlert p15'>Report <b><i>@" +
          $user +
          "</i></b> feedback for " +
          $scriptID +
          ":</div>";
        $feedbackReportPane +=
          "<div class='iframe-document-wrap'>" + $feedbackPane + "</div>";

        $feedbackReportPane +=
          "<div class='p15' style='background: #e2e2e2; position: relative; margin-top: 20px;'><div class='card-lt-wraps'><div class='card-lt'><div id='response-message' class='hide'> </div>";
        $feedbackReportPane +=
          "<div class='card-form-lt'><div class='title-lt'>Report Feedback</div>";
        $feedbackReportPane +=
          "<form route='submit'><input type='hidden' id='feedbackScriptID' value='" +
          $scriptID +
          "'/><input type='hidden' id='feedbackID' value='" +
          $feedbackID +
          "'/><div class='ResposeMessage'></div>";
        $feedbackReportPane +=
          "<div class='form-group-lt'><textarea class='input-lt' id='reportFeedback' placeholder='Tell us the reason why you are reporting this feedback, describe why you think it is inappropriate' rows='15' cols='50' maxlength='500'></textarea></div>";
        $feedbackReportPane +=
          "<div class='form-group-lt chip-flex flex-center'><button class='button-lt-small blue' id='submit-feedback-report' data-scriptid='" +
          $scriptID +
          "'><i class='fa fa-thumbs-down'> </i> Submit Report</button></div>";
        $feedbackReportPane += "</form></div></div></div>";

        let $feedbackReportModal = $feedbackReportPane;

        popModal("large", {
          title: `Report feedback for ${$scriptID}`,
          body: $feedbackReportModal,
        });
      });
    });

    $(function () {
      $(document).on("click", "#revise-file", function (e) {
        e.preventDefault();
        //$(document).find('#revise-file').off('click');
        let $scriptID = $(document).find("#reviewScriptID").val();
        let $scriptReviewPhase = $(document).find("#reviewPhase").val();
        let $reviewFeedback = $(document).find("#reviewFeedback").val();
        let $reviewFeedbackFile = $(document)
          .find("#reviewFeedbackFile")
          ?.prop("files");
        $(document).find("#response-message").addClass("hide");
        doReviewsubmit(
          that,
          $reviewFeedback,
          $reviewFeedbackFile,
          $scriptID,
          $scriptReviewPhase,
          "revise"
        );
        return false;
      });

      $(document).on("click", "#reject-file", function (e) {
        e.preventDefault();
        //$(document).find('#reject-file').off('click');
        let $scriptID = $(document).find("#reviewScriptID").val();
        let $scriptReviewPhase = $(document).find("#reviewPhase").val();
        let $reviewFeedback = $(document).find("#reviewFeedback").val();
        let $reviewFeedbackFile = $(document)
          .find("#reviewFeedbackFile")
          ?.prop("files");
        $(document).find("#response-message").addClass("hide");

        let proceed = true;
        if (getState(that, "editor") > 0) {
          proceed = window.confirm(
            "An editor's 'Decline' of a paper is a rejection. Are you sure you want to reject this paper?"
          );
        }

        if (proceed) {
          doReviewsubmit(
            that,
            $reviewFeedback,
            $reviewFeedbackFile,
            $scriptID,
            $scriptReviewPhase,
            "reject"
          );
        }
        return false;
      });

      $(document).on("click", "#accept-file", function (e) {
        e.preventDefault();
        //$(document).find('#accept-file').off('click');
        let $scriptID = $(document).find("#reviewScriptID").val();
        let $scriptReviewPhase = $(document).find("#reviewPhase").val();
        let $reviewFeedback = $(document).find("#reviewFeedback").val();
        let $reviewFeedbackFile = $(document)
          .find("#reviewFeedbackFile")
          ?.prop("files");
        $(document).find("#response-message").addClass("hide");
        doReviewsubmit(
          that,
          $reviewFeedback,
          $reviewFeedbackFile,
          $scriptID,
          $scriptReviewPhase,
          "accept"
        );
        return false;
      });

      $(document).on("click", "#submit-feedback-report", function (e) {
        e.preventDefault();
        //$(document).find('#accept-file').off('click');
        let $scriptID = $(document).find("#feedbackScriptID").val();
        let $feedbackID = $(document).find("#feedbackID").val();
        let $reportFeedback = $(document).find("#reportFeedback").val();
        $(document).find("#response-message").addClass("hide");

        //alert($scriptID+" + "+$feedbackID+" - "+$reportFeedback)
        //(Note: do not report feedback if it's an appropriate one)
        let aRole = window.confirm(
          "Are you sure you want to report the Feedback under script ID: " +
            $scriptID +
            " which means the Feedback is inappropriate? if yes click OK, and if no please cancel"
        );
        if (aRole) {
          doReportFeedback(that, $reportFeedback, $scriptID, $feedbackID);
          return false;
        } else {
          alert(
            "You have cancelled to report the Feedback under script ID: " +
              $scriptID +
              " successfully!"
          );
          return false;
        }
        return false;
      });

      $(document).on("click", "#submit-external-reviewer", function (e) {
        e.preventDefault();
        let $scriptID = $(document).find("#externalScriptID").val();
        let $reviewerFullName = $(document).find("#reviewerFullName").val();
        let $reviewerEmail = $(document).find("#reviewerEmail").val();
        $(document).find("#response-message").addClass("hide");

        let aRole = window.confirm(
          "Are you sure you want to invite a reviewer for script ID: " +
            $scriptID +
            " ? if yes click OK, and if no please cancel"
        );
        if (aRole) {
          doInviteExternalReviewer(
            that,
            $reviewerFullName,
            $reviewerEmail,
            $scriptID
          );
          return false;
        } else {
          alert("You have cancelled. ");
          return false;
        }
      });

      $(document).on("click", "#commit-script", function (e) {
        e.preventDefault();

        let $scriptID = $(document).find("#reviewScriptID").val();
        let $commitPledge = $(document).find("#commit_pledge:checked").val();
        let $commitPledgeConfirmation = $(document)
          .find("#commit_pledge_confirmation:checked")
          .val();
        $(document).find("#response-message").addClass("hide");

        if (typeof $commitPledge === "undefined") {
          alert("Please select to commit as either Editor or Reviewer");
        } else if (typeof $commitPledgeConfirmation === "undefined") {
          alert("Please accept to commit to script ID: " + $scriptID);
        }
        if (
          typeof $commitPledge !== "undefined" &&
          typeof $commitPledgeConfirmation !== "undefined"
        ) {
          const ArrRole = { 0: "an Editor", 1: "a Reviewer" };
          let aRole = window.confirm(
            "Are you sure you want to commit to script ID: " +
              $scriptID +
              " as " +
              ArrRole[$commitPledge] +
              "? if yes click OK, and if no please cancel"
          );
          if (aRole) {
            doReviewCommit(
              that,
              $commitPledge,
              $scriptID,
              $commitPledgeConfirmation
            );
            return false;
          } else {
            alert(
              "You have cancelled to commit to script ID: " +
                $scriptID +
                " successfully!"
            );
            return false;
          }
        }
      });
    });
  }

  componentDidUpdate(prevProps) {
    //this.loadDataFromServer(this.props.cmd, getState(this, 'offset'), getState(this, 'limit'));
  }

  AlertNoTableData = (len) => {
    return (
      <tr>
        <td colspan={len}>
          <div className="p15 center block">
            No Table Data - No Result found!
          </div>
        </td>
      </tr>
    );
  };

  clearPagingData = () => {
    UpdateState(this, "page", 1);
    UpdateState(this, "total_page", 1);
    UpdateState(this, "total_result", 0);
    UpdateState(this, "offset", "-1");
    UpdateState(this, "offset_set", 0);
  };

  updatePageTarget(target) {
    UpdateState(this, "page_target", target);
  }

  updatePageRegionTarget(target) {
    UpdateState(this, "specific_region", target);
  }

  handlePageClick = (data) => {
    let selected = data.selected;
    let offset = Math.ceil(selected * limit_per_page);
    UpdateState(this, "offset", offset == 0 ? "-1" : offset);
    UpdateState(this, "offset_set", offset);
    UpdateState(this, "page", selected + 1);
    let $specifit = getState(this, "page_target") == "1" ? "1" : "";
    let $specific_region =
      getState(this, "specific_region") != ""
        ? getState(this, "specific_region")
        : "";
    if ($specific_region != "") {
      this.loadDataFromServer(
        this.props.cmd,
        getState(this, "offset"),
        getState(this, "limit"),
        "",
        $specific_region
      );
    } else if ($specifit != "") {
      this.loadDataFromServer(
        this.props.cmd,
        getState(this, "offset"),
        getState(this, "limit"),
        $specifit,
        ""
      );
    } else {
      this.loadDataFromServer(
        this.props.cmd,
        getState(this, "offset"),
        getState(this, "limit"),
        "",
        ""
      );
    }
  };

  loadDataFromServer = async (
    cmd,
    offset,
    limit,
    specific = "",
    specific_region = ""
  ) => {
    UpdateState(this, "loading", "1");

    let DeviceSid = await FingerPrint();

    let header = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization:
          "Bearer " +
          getSession("token") +
          ", Session " +
          DeviceSid +
          ", Platform " +
          platform,
        "My-Custom-Header": name,
        "User-Agent": name + " Bot",
      },
    };

    let datas = new URLSearchParams({
      command: "fetch",
      cmd: this.props.cmd,
      user_id: getSession("userID"),
      limit: getState(this, "limit"),
      offset: getState(this, "offset"),
      page: getState(this, "page"),
      specific: specific?.length ? specific : "",
      specific_region: specific_region?.length ? specific_region : "",
      my_commit: this.props?.commit || 0,
    }).toString();

    axios
      .get(ApiEndpoint + "/fetchResult?" + datas, header)
      .then((response) => {
        UpdateState(this, "loading", "0");

        if (response?.data?.retry == true) {
          let retryTimes =
            getState(this, "retry_times") >= 0 &&
            getState(this, "retry_times") != ""
              ? getState(this, "retry_times")
              : "";
          if (retryTimes != "") {
            if (getState(this, "retry_times") < 15) {
              setTimeout(function () {
                UpdateState(
                  this,
                  "retry_times",
                  getState(this, "retry_times") + 1
                );
                this.loadDataFromServer(cmd, offset, limit);
              }, 4000);
            }
          }
        }

        if (response?.data?.error == false && response?.data?.error != true) {
          setSession("div_message", response?.data?.division?.message);
          setSession("division", response?.data?.division?.name);
          UpdateState(
            this,
            "data",
            response?.data?.data?.length > 0 ? response?.data?.data : []
          );
          UpdateState(this, "reported", response?.data?.reported);
          UpdateState(this, "editor", response?.data?.editor);
          UpdateState(this, "reviewer", response?.data?.reviewer);
          UpdateState(this, "total_page", response?.data?.total_page);
          UpdateState(this, "total_result", response?.data?.total_result);
          UpdateState(this, "message", "");
          UpdateState(this, "loading", "0");

          $(function () {
            $(".disabled").each(function () {
              //$(this).prop('title', "Disabled and Unavailable for Click Option");
            });
          });
        } else if (response?.data?.error != false) {
          AlertMessage(this, response?.data?.error, "error");
          UpdateState(this, "loading", "0");
          if (
            response?.data?.logout == true &&
            response?.data?.token == false
          ) {
            setTimeout(function () {
              clearSession();
              window.location.href = "/login";
            }, 4000);
          }
        } else {
          UpdateState(this, "loading", "0");
          AlertMessage(
            this,
            "Something went wrong, try again or try to reload the page!",
            "error"
          );
        }
      })
      .catch((err) => {
        UpdateState(this, "loading", "0");
        AlertMessage(
          this,
          "Something went wrong, try again or try to reload the page!\n\r" +
            err,
          "error"
        );
        this.loadDataFromServer(cmd, offset, limit);
      });
  };

  removeScriptEditor = async (id) => {
    if (getState(this, "editor") > 0) {
      let ask = window.confirm(
        "Only malicious and inappropriate scripts should be deleted. To Reject a script, click the Review [R] button, enter your reason(s) for rejection, choose Decline on the scoreboard and the script is rejected. To delete this script ID: " +
          id +
          ", please confirm the script is malicious or inappropriate."
      );

      if (ask) {
        let DeviceSid = await FingerPrint();

        let reviewError = "";
        let classError = "";

        if (id == "") {
          reviewError = "ScriptID is required";
        }

        if (reviewError == "") {
          let header = {
            headers: {
              Accept: "application/json",
              //'Content-Type': "multipart/form-data",
              "Content-Type": "application/x-www-form-urlencoded",
              Authorization:
                "Bearer " +
                getSession("token") +
                ", Session " +
                DeviceSid +
                ", Platform " +
                platform,
              "My-Custom-Header": name,
              "User-Agent": name + " Bot",
            },
          };

          let datas = {
            cmd: "remove_script",
            user_id: getSession("userID"),
            scriptID: id,
          };

          axios
            .post(ApiEndpoint + "/remove_script?q=doSubmit", datas, header)
            .then((response) => {
              UpdateState(this, "loading", "0");

              if (
                response?.data?.error == false &&
                response?.data?.error != true
              ) {
                AlertMessage(this, response?.data?.message, "success");

                setTimeout(function () {
                  window.location.reload();
                }, 8000);
              } else if (response?.data?.error != false) {
                AlertMessage(this, response?.data?.error, "error");

                if (
                  response?.data?.logout == true &&
                  response?.data?.token == false
                ) {
                  setTimeout(function () {
                    clearSession();
                    window.location.href = "/login";
                  }, 20000);
                }
              } else {
                AlertMessage(
                  this,
                  "Something went wrong, try again or try to reload the page!",
                  "error"
                );
              }
            })
            .catch((err) => {
              AlertMessage(
                this,
                "Something went wrong, try again or try to reload the page!\n\r" +
                  err,
                "error"
              );

              UpdateState(this, "loading", "0");
            });
        } else {
          AlertMessage(this, reviewError, "error");

          UpdateState(this, "loading", "0");
        }
      } else {
        window.alert(
          "You have cancelled to Delete/Remove ScriptID: " +
            id +
            ", it won't be removed from the system"
        );
      }
    }
  };

  render() {
    return (
      <>
        <div className="responsive-tables">
          {getState(this, "loading") == "1" ? (
            <div className="table-loader">
              <div className="overlay">
                <div className="overlay__inner">
                  <div className="overlay__content">
                    <span className="spinner"></span>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}

          {AlertMessageOut(this)}

          <div className="card-lt-wraps">
            <div className="card-lts">
              <div className="tab mtb10">
                <div className="tab-tab tab-label">
                  <span className="fa fa-filter"></span>
                </div>
                <div
                  className="tab-link tab-tab active"
                  onClick={(event) => {
                    this.updatePageTarget("0");
                    this.updatePageRegionTarget("");
                    this.clearPagingData();
                    this.loadDataFromServer(
                      this.props.cmd,
                      getState(this, "offset"),
                      getState(this, "limit")
                    );
                  }}
                >
                  <i className="fa fa-thumbs-up"></i> On Review Script
                </div>
                <div
                  className="tab-link tab-tab"
                  onClick={(event) => {
                    this.updatePageTarget("1");
                    this.clearPagingData();
                    this.loadDataFromServer(
                      this.props.cmd,
                      getState(this, "offset"),
                      getState(this, "limit"),
                      "1"
                    );
                  }}
                >
                  <i className="fa fa-check-circle"></i> Concluded Script
                </div>
                <div
                  className="tab-link tab-tab"
                  hidden={hideRegion}
                  onClick={(event) => {
                    this.updatePageTarget("0");
                    this.updatePageRegionTarget(getSession("region"));
                    this.clearPagingData();
                    this.loadDataFromServer(
                      this.props.cmd,
                      getState(this, "offset"),
                      getState(this, "limit"),
                      "",
                      getSession("region")
                    );
                  }}
                >
                  <i className="fa fa-map-marker"></i> {getSession("region")}
                </div>
                <div
                  className="tab-link tab-tab"
                  hidden={hideRegion}
                  onClick={(event) => {
                    this.updatePageTarget("0");
                    this.updatePageRegionTarget("-1");
                    this.clearPagingData();
                    this.loadDataFromServer(
                      this.props.cmd,
                      getState(this, "offset"),
                      getState(this, "limit"),
                      "",
                      "-1"
                    );
                  }}
                >
                  <i className="fa fa-globe"></i> Global
                </div>
              </div>
            </div>
          </div>

          <div className="responsive-table">
            <table>
              <thead>
                <tr>
                  <th>S/N</th>
                  {this.props.th?.map((th, i) => {
                    return (
                      <th
                        className={this.props.thclassX[i]}
                        key={i}
                        hidden={i == 1 && hideRegion}
                      >
                        {th}
                      </th>
                    );
                  })}
                </tr>
              </thead>

              <tbody>
                {getState(this, "data")?.length == 0
                  ? this.AlertNoTableData(this.props.th.length + 1)
                  : ""}
                {getState(this, "data")?.map((td, i) => {
                  let $document_iFrame = "";
                  let $reviewModal = "";
                  let $externalLinkModal = "";
                  let $feedbackModal = "";
                  let $FeedBackList = "";
                  let $document_iFrame2 = "";
                  let $reviewModal2 = "";
                  let $feedbackModal2 = "";
                  let $FeedBackList2 = "";
                  let $document_iFrame3 = "";
                  let $reviewModal3 = "";
                  let $feedbackModal3 = "";
                  let $FeedBackList3 = "";
                  let $hasCommitted = false;

                  $externalLinkModal +=
                    "<div class='p15' style='background: #e2e2e2; position: relative; margin-top: 20px;'>" +
                    "<div class='card-lt-wraps'>" +
                    "<div class='card-lt'>" +
                    "<div id='external-response-message' class='hide'></div>" +
                    "<div class='card-form-lt'>" +
                    "<div class='title-lt'>Get an external reviewer</div>" +
                    "<form route='submit'>";

                  // Hidden Script ID
                  $externalLinkModal +=
                    "<input type='hidden' id='externalScriptID' name='script_id' value='" +
                    td["scriptID"] +
                    "'/>";

                  // Full Name Input
                  $externalLinkModal +=
                    "<div class='form-group-lt'>" +
                    "<label for='full_name'>Full Name:</label>" +
                    "<input type='text' id='reviewerFullName' name='full_name' class='input-lt' placeholder='Enter full name' required />" +
                    "</div>";

                  // Email Input
                  $externalLinkModal +=
                    "<div class='form-group-lt'>" +
                    "<label for='email'>Reviewer Email Address:</label>" +
                    "<input type='email' id='reviewerEmail' name='email' class='input-lt' placeholder='Enter email address' required />" +
                    "</div>";

                  // Submit Button
                  $externalLinkModal +=
                    "<div class='form-group-lt chip-flex flex-center'>" +
                    "<button class='button-lt-small blue' id='submit-external-reviewer' data-scriptid='" +
                    td["scriptID"] +
                    "'>" +
                    "<i class='fa fa-paper-plane'></i> Send Link" +
                    "</button>" +
                    "</div>";

                  $externalLinkModal +=
                    "</form>" + "</div>" + "</div>" + "</div>" + "</div>";

                  //alert(td['review']['r1']['file_ext']);
                  $FeedBackList +=
                    td["feedback"]["f1"]?.length < 1
                      ? "<div class='error'>No Feedback to display</div>"
                      : "";
                  $FeedBackList2 +=
                    td["feedback"]["f2"]?.length < 1
                      ? "<div class='error'>No Feedback to display</div>"
                      : "";
                  $FeedBackList3 +=
                    td["feedback"]["f3"]?.length < 1
                      ? "<div class='error'>No Feedback to display</div>"
                      : "";
                  {
                    td["feedback"]["f1"]?.map((feed, i) => {
                      $FeedBackList +=
                        "<div data-key='" +
                        i +
                        "' style='margin-bottom: 10px;'><blockquote style='text-align: left; font-size: 16px;width:100%; margin:20px auto; font-family:Open Sans; font-style:italic;  color: #555555; padding:14px; padding-top: 50px; border-radius: 5px; border: 1px solid rgba(213,210,229,.8); line-height:1.6; position: relative; background: #fafafa;'>" +
                        feed["feedback"] +
                        "<span style='display:block;color:#333333;font-style: normal;font-weight: bold; margin-top:17px; font-size: 15px;'><i class='fa fa-user-circle'></i> " +
                        feed["user"] +
                        "</span><span style='position: absolute;top: 0; right: 0; padding: 8px 16px;font-weight: 600;font-size: 12px;box-shadow: 0 2px 5px rgba(0,0,0,.25);margin: 4px 4px 0px 0px; border-radius: 5px;' class='chip vote " +
                        feed["vote_class"] +
                        "'>" +
                        feed["vote"] +
                        "</span>";
                      if (td["own_script"] == "1" && feed["reported"] == "0") {
                        $FeedBackList +=
                          "<span id='report-feedback' data-feedbackid='" +
                          feed["id"] +
                          "' data-scriptid='" +
                          td["scriptID"] +
                          "' data-user='" +
                          feed["user"] +
                          "' data-feedback='" +
                          feed["feedback"] +
                          "' data-voteclass='" +
                          feed["vote_class"] +
                          "' data-vote='" +
                          feed["vote"] +
                          "' style='position: absolute;bottom: 6px; right: 0; padding: 5px 10px;font-weight: 600;font-size: 12px;box-shadow: 0 2px 5px rgba(0,0,0,.25);margin: 4px 4px 0px 0px; border-radius: 5px; background: purple; color: #fff;' class='chip dangerXs'><i class='fa fa-thumbs-down'> </i> Report</span>";
                      }
                      if (td["own_script"] == "1" && feed["reported"] == "1") {
                        $FeedBackList +=
                          "<span id='reported-feedback' style='position: absolute;bottom: 6px; right: 0; padding: 5px 10px;font-weight: 600;font-size: 12px;box-shadow: 0 2px 5px rgba(0,0,0,.25);margin: 4px 4px 0px 0px; border-radius: 5px; background: #414750 ; color: #fff;' class='chip secondaryXs disabled'><i class='fa fa-exclamation-circle'> </i> Reported</span>";
                      }
                      $FeedBackList += "</blockquote></div>";
                    });
                  }

                  if (td["review_phase"] >= 2) {
                    $FeedBackList2 +=
                      td["feedback"]["f2"]?.length < 1
                        ? "<div class='error'>No Feedback to display</div>"
                        : "";
                    {
                      td["feedback"]["f2"]?.map((feed, i) => {
                        $FeedBackList2 +=
                          "<div data-key='" +
                          i +
                          "' style='margin-bottom: 10px;'><blockquote style='text-align: left; font-size: 16px;width:100%; margin:20px auto; font-family:Open Sans; font-style:italic;  color: #555555; padding:14px; padding-top: 50px; border-radius: 5px; border: 1px solid rgba(213,210,229,.8); line-height:1.6; position: relative; background: #fafafa;'>" +
                          feed["feedback"] +
                          "<span style='display:block;color:#333333;font-style: normal;font-weight: bold; margin-top:17px; font-size: 15px;'><i class='fa fa-user-circle'></i> " +
                          feed["user"] +
                          "</span><span style='position: absolute;top: 0; right: 0; padding: 8px 16px;font-weight: 600;font-size: 12px;box-shadow: 0 2px 5px rgba(0,0,0,.25);margin: 4px 4px 0px 0px; border-radius: 5px;' class='chip vote " +
                          feed["vote_class"] +
                          "'>" +
                          feed["vote"] +
                          "</span>";
                        if (
                          td["own_script"] == "1" &&
                          feed["reported"] == "0"
                        ) {
                          $FeedBackList2 +=
                            "<span id='report-feedback' data-feedbackid='" +
                            feed["id"] +
                            "' data-scriptid='" +
                            td["scriptID"] +
                            "' data-user='" +
                            feed["user"] +
                            "' data-feedback='" +
                            feed["feedback"] +
                            "' data-voteclass='" +
                            feed["vote_class"] +
                            "' data-vote='" +
                            feed["vote"] +
                            "' style='position: absolute;bottom: 6px; right: 0; padding: 5px 10px;font-weight: 600;font-size: 12px;box-shadow: 0 2px 5px rgba(0,0,0,.25);margin: 4px 4px 0px 0px; border-radius: 5px; background: purple; color: #fff;' class='chip dangerXs'><i class='fa fa-thumbs-down'> </i> Report</span>";
                        }
                        if (
                          td["own_script"] == "1" &&
                          feed["reported"] == "1"
                        ) {
                          $FeedBackList2 +=
                            "<span id='reported-feedback' style='position: absolute;bottom: 6px; right: 0; padding: 5px 10px;font-weight: 600;font-size: 12px;box-shadow: 0 2px 5px rgba(0,0,0,.25);margin: 4px 4px 0px 0px; border-radius: 5px; background: #414750 ; color: #fff;' class='chip secondaryXs disabled'><i class='fa fa-exclamation-circle'> </i> Reported</span>";
                        }
                        $FeedBackList2 += "</blockquote></div>";
                      });
                    }
                  }

                  if (td["review_phase"] >= 3) {
                    $FeedBackList3 +=
                      td["feedback"]["f3"]?.length < 1
                        ? "<div class='error'>No Feedback to display</div>"
                        : "";
                    {
                      td["feedback"]["f3"]?.map((feed, i) => {
                        $FeedBackList3 +=
                          "<div data-key='" +
                          i +
                          "' style='margin-bottom: 10px;'><blockquote style='text-align: left; font-size: 16px;width:100%; margin:20px auto; font-family:Open Sans; font-style:italic;  color: #555555; padding:14px; padding-top: 50px; border-radius: 5px; border: 1px solid rgba(213,210,229,.8); line-height:1.6; position: relative; background: #fafafa;'>" +
                          feed["feedback"] +
                          "<span style='display:block;color:#333333;font-style: normal;font-weight: bold; margin-top:17px; font-size: 15px;'><i class='fa fa-user-circle'></i> " +
                          feed["user"] +
                          "</span><span style='position: absolute;top: 0; right: 0; padding: 8px 16px;font-weight: 600;font-size: 12px;box-shadow: 0 2px 5px rgba(0,0,0,.25);margin: 4px 4px 0px 0px; border-radius: 5px;' class='chip vote " +
                          feed["vote_class"] +
                          "'>" +
                          feed["vote"] +
                          "</span>";
                        if (
                          td["own_script"] == "1" &&
                          feed["reported"] == "0"
                        ) {
                          $FeedBackList3 +=
                            "<span id='report-feedback' data-feedbackid='" +
                            feed["id"] +
                            "' data-scriptid='" +
                            td["scriptID"] +
                            "' data-user='" +
                            feed["user"] +
                            "' data-feedback='" +
                            feed["feedback"] +
                            "' data-voteclass='" +
                            feed["vote_class"] +
                            "' data-vote='" +
                            feed["vote"] +
                            "' style='position: absolute;bottom: 6px; right: 0; padding: 5px 10px;font-weight: 600;font-size: 12px;box-shadow: 0 2px 5px rgba(0,0,0,.25);margin: 4px 4px 0px 0px; border-radius: 5px; background: purple; color: #fff;' class='chip dangerXs'><i class='fa fa-thumbs-down'> </i> Report</span>";
                        }
                        if (
                          td["own_script"] == "1" &&
                          feed["reported"] == "1"
                        ) {
                          $FeedBackList3 +=
                            "<span id='reported-feedback' style='position: absolute;bottom: 6px; right: 0; padding: 5px 10px;font-weight: 600;font-size: 12px;box-shadow: 0 2px 5px rgba(0,0,0,.25);margin: 4px 4px 0px 0px; border-radius: 5px; background: #414750 ; color: #fff;' class='chip secondaryXs disabled'><i class='fa fa-exclamation-circle'> </i> Reported</span>";
                        }
                        $FeedBackList3 += "</blockquote></div>";
                      });
                    }
                  }

                  //File 1
                  if (td["review"]["r1"]["file_ext"] === "pdfd") {
                    $hasCommitted =
                      td["commit"]["my_reviewer_commit"] > 0 ||
                      td["commit"]["my_editor_commit"] > 0;
                    $document_iFrame +=
                      "<div class='' style='padding-bottom: 8px; text-align:center;'>" +
                      "<button class='go-full-screen-iframe'>" +
                      "<i class='fa fa-arrows-alt' style='-ms-transform: rotate(45deg); transform: rotate(45deg);'></i> Read " +
                      td["review"]["r1"]["file_ext"]?.toUpperCase() +
                      " on Fullscreen" +
                      "</button> " +
                      "<button data-file-uri='" +
                      td["review"]["r1"]["file_url"] +
                      "' class='download-file chip primaryX'" +
                      ($hasCommitted ? "" : " disabled") +
                      "><i class='fa fa-download'></i> Download " +
                      td["review"]["r1"]["file_ext"]?.toUpperCase() +
                      " File</button>" +
                      "</div>" +
                      "<iframe class='modal-iframe' width='100%' height='400px' frameborder='0' src='" +
                      td["review"]["r1"]["file"] +
                      "'>Loaded from Direct Page </iframe>";
                  } else if (
                    td["review"]["r1"]["file_ext"] === "doc" ||
                    td["review"]["r1"]["file_ext"] === "docx" ||
                    td["review"]["r1"]["file_ext"] === "odt"
                  ) {
                    $hasCommitted =
                      td["commit"]["my_reviewer_commit"] > 0 ||
                      td["commit"]["my_editor_commit"] > 0;
                    $document_iFrame +=
                      "<div style='padding-bottom: 8px; text-align:center;'>" +
                      "<button class='go-full-screen-iframe'>" +
                      "<i class='fa fa-arrows-alt' style='-ms-transform: rotate(45deg); transform: rotate(45deg);'></i> Read " +
                      td["review"]["r1"]["file_ext"]?.toUpperCase() +
                      " on Fullscreen" +
                      "</button> " +
                      "<button data-file-uri='" +
                      td["review"]["r1"]["file_url"] +
                      "' class='download-file chip primaryX'" +
                      ($hasCommitted ? "" : " disabled") +
                      "><i class='fa fa-download'></i> Download " +
                      td["review"]["r1"]["file_ext"]?.toUpperCase() +
                      " File</button>" +
                      "</div>" +
                      "<iframe class='modal-iframe' width='100%' height='400px' frameborder='0'";
                    $document_iFrame +=
                      "src='https://view.officeapps.live.com/op/embed.aspx?src=";
                    $document_iFrame +=
                      td["review"]["r1"]["file"] +
                      "' allowFullScreen>This is an embedded <a target='_blank' href='http://office.com'>Microsoft Office</a> document, powered by <a target='_blank' href='http://office.com/webapps'>Office Online</a>.</iframe>";
                  } else if (
                    td["review"]["r1"]["file_ext"] === "rtf" ||
                    td["review"]["r1"]["file_ext"] === "pdf"
                  ) {
                    $hasCommitted =
                      td["commit"]["my_reviewer_commit"] > 0 ||
                      td["commit"]["my_editor_commit"] > 0;
                    $document_iFrame +=
                      "<div class='' style='padding-bottom: 8px; text-align:center;'>" +
                      "<button class='go-full-screen-iframe'>" +
                      "<i class='fa fa-arrows-alt' style='-ms-transform: rotate(45deg); transform: rotate(45deg);'></i> Read " +
                      td["review"]["r1"]["file_ext"]?.toUpperCase() +
                      " on FullScreen" +
                      "</button> " +
                      "<button data-file-uri='" +
                      td["review"]["r1"]["file_url"] +
                      "' class='download-file chip primaryX'" +
                      ($hasCommitted ? "" : " disabled") +
                      "><i class='fa fa-download'></i> Download " +
                      td["review"]["r1"]["file_ext"]?.toUpperCase() +
                      " File</button>" +
                      "</div>" +
                      "<iframe class='modal-iframe' width='100%' height='400px' frameborder='0' src='https://docs.google.com/gview?url=" +
                      td["review"]["r1"]["file"] +
                      "&embedded=true' allowFullScreen>Google Drive Api Dirrect </iframe>";
                  } else {
                    $document_iFrame +=
                      "<br/><div class='warning-no'> <center><img src='" +
                      FileUnsupported +
                      "' alt='File Unsupported'/><br/><br/><br/> File doesn't support online read for <b>." +
                      td["review"]["r1"]["file_ext"] +
                      "</b> file, kindly download the file below to read on your Device locally!</center></div>";
                  }

                  //File 2
                  if (td["review_phase"] >= 2) {
                    if (td["review"]["r2"]["file_ext"] === "pdfd") {
                      $document_iFrame2 +=
                        "<div class='' style='padding-bottom: 8px; text-align:center;'><button class='go-full-screen-iframe'><i class='fa fa-arrows-alt' style='-ms-transform: rotate(45deg); transform: rotate(45deg);'> </i> Read " +
                        td["review"]["r2"]["file_ext"]?.toUpperCase() +
                        " on Fullscreen</button> <button data-file-uri='" +
                        td["review"]["r2"]["file_url"] +
                        "' class='download-file chip primaryX'><i class='fa fa-download'></i> Download " +
                        td["review"]["r2"]["file_ext"]?.toUpperCase() +
                        " File</button></div><iframe class='modal-iframe' width='100%' height='400px' frameborder='0' src='" +
                        td["review"]["r2"]["file"] +
                        "'>Loaded from Direct Page </iframe>";
                    } else if (
                      td["review"]["r2"]["file_ext"] === "doc" ||
                      td["review"]["r2"]["file_ext"] === "docx" ||
                      td["review"]["r2"]["file_ext"] === "odt"
                    ) {
                      $document_iFrame2 +=
                        "<div class='' style='padding-bottom: 8px; text-align:center;'><button class='go-full-screen-iframe'><i class='fa fa-arrows-alt' style='-ms-transform: rotate(45deg); transform: rotate(45deg);'> </i> Read " +
                        td["review"]["r2"]["file_ext"]?.toUpperCase() +
                        " on Fullscreen</button> <button data-file-uri='" +
                        td["review"]["r2"]["file_url"] +
                        "' class='download-file chip primaryX'><i class='fa fa-download'></i> Download " +
                        td["review"]["r2"]["file_ext"]?.toUpperCase() +
                        " File</button></div><iframe class='modal-iframe' width='100%' height='400px' frameborder='0'";
                      $document_iFrame2 +=
                        "src='https://view.officeapps.live.com/op/embed.aspx?src=";
                      $document_iFrame2 +=
                        td["review"]["r2"]["file"] +
                        "' allowFullScreen>This is an embedded <a target='_blank' href='http://office.com'>Microsoft Office</a> document, powered by <a target='_blank' href='http://office.com/webapps'>Office Online</a>.</iframe>";
                    } else if (
                      td["review"]["r2"]["file_ext"] === "rtf" ||
                      td["review"]["r2"]["file_ext"] === "pdf"
                    ) {
                      $document_iFrame2 +=
                        "<div class='' style='padding-bottom: 8px; text-align:center;'><button class='go-full-screen-iframe'><i class='fa fa-arrows-alt' style='-ms-transform: rotate(45deg); transform: rotate(45deg);'> </i> Read " +
                        td["review"]["r2"]["file_ext"]?.toUpperCase() +
                        " on FullScreen</button> <button data-file-uri='" +
                        td["review"]["r2"]["file_url"] +
                        "' class='download-file chip primaryX'><i class='fa fa-download'></i> Download " +
                        td["review"]["r2"]["file_ext"]?.toUpperCase() +
                        " File</button></div><iframe class='modal-iframe' width='100%' height='400px' frameborder='0' src='https://docs.google.com/gview?url=" +
                        td["review"]["r2"]["file"] +
                        "&embedded=true' allowFullScreen>Google Drive Api Dirrect </iframe>";
                    } else {
                      $document_iFrame2 +=
                        "<br/><div class='warning-no'> <center><img src='" +
                        FileUnsupported +
                        "' alt='File Unsupported'/><br/><br/><br/> File doesn't support online read for <b>." +
                        td["review"]["r2"]["file_ext"] +
                        "</b> file, kindly download the file below to read on your Device locally!</center></div>";
                    }
                  }

                  //File 3
                  if (td["review_phase"] >= 3) {
                    if (td["review"]["r3"]["file_ext"] === "pdfd") {
                      $document_iFrame3 +=
                        "<div class='' style='padding-bottom: 8px; text-align:center;'><button class='go-full-screen-iframe'><i class='fa fa-arrows-alt' style='-ms-transform: rotate(45deg); transform: rotate(45deg);'> </i> Read " +
                        td["review"]["r3"]["file_ext"]?.toUpperCase() +
                        " on Fullscreen</button> <button data-file-uri='" +
                        td["review"]["r3"]["file_url"] +
                        "' class='download-file chip primaryX'><i class='fa fa-download'></i> Download " +
                        td["review"]["r3"]["file_ext"]?.toUpperCase() +
                        " File</button></div><iframe class='modal-iframe' width='100%' height='400px' frameborder='0' src='" +
                        td["review"]["r3"]["file"] +
                        "'>Loaded from Direct Page </iframe>";
                    } else if (
                      td["review"]["r3"]["file_ext"] === "doc" ||
                      td["review"]["r3"]["file_ext"] === "docx" ||
                      td["review"]["r3"]["file_ext"] === "odt"
                    ) {
                      $document_iFrame3 +=
                        "<div class='' style='padding-bottom: 8px; text-align:center;'><button class='go-full-screen-iframe'><i class='fa fa-arrows-alt' style='-ms-transform: rotate(45deg); transform: rotate(45deg);'> </i> Read " +
                        td["review"]["r3"]["file_ext"]?.toUpperCase() +
                        " on Fullscreen</button> <button data-file-uri='" +
                        td["review"]["r3"]["file_url"] +
                        "' class='download-file chip primaryX'><i class='fa fa-download'></i> Download " +
                        td["review"]["r3"]["file_ext"]?.toUpperCase() +
                        " File</button></div><iframe class='modal-iframe' width='100%' height='400px' frameborder='0'";
                      $document_iFrame3 +=
                        "src='https://view.officeapps.live.com/op/embed.aspx?src=";
                      $document_iFrame3 +=
                        td["review"]["r3"]["file"] +
                        "' allowFullScreen>This is an embedded <a target='_blank' href='http://office.com'>Microsoft Office</a> document, powered by <a target='_blank' href='http://office.com/webapps'>Office Online</a>.</iframe>";
                    } else if (
                      td["review"]["r3"]["file_ext"] === "rtf" ||
                      td["review"]["r3"]["file_ext"] === "pdf"
                    ) {
                      $document_iFrame3 +=
                        "<div class='' style='padding-bottom: 8px; text-align:center;'><button class='go-full-screen-iframe'><i class='fa fa-arrows-alt' style='-ms-transform: rotate(45deg); transform: rotate(45deg);'> </i> Read " +
                        td["review"]["r3"]["file_ext"]?.toUpperCase() +
                        " on FullScreen</button> <button data-file-uri='" +
                        td["review"]["r3"]["file_url"] +
                        "' class='download-file chip primaryX'><i class='fa fa-download'></i> Download " +
                        td["review"]["r3"]["file_ext"]?.toUpperCase() +
                        " File</button></div><iframe class='modal-iframe' width='100%' height='400px' frameborder='0' src='https://docs.google.com/gview?url=" +
                        td["review"]["r3"]["file"] +
                        "&embedded=true' allowFullScreen>Google Drive Api Dirrect </iframe>";
                    } else {
                      $document_iFrame3 +=
                        "<br/><div class='warning-no'> <center><img src='" +
                        FileUnsupported +
                        "' alt='File Unsupported'/><br/><br/><br/> File doesn't support online read for <b>." +
                        td["review"]["r3"]["file_ext"] +
                        "</b> file, kindly download the file below to read on your Device locally!</center></div>";
                    }
                  }

                  if (
                    td["commit"]["my_reviewer_commit"] > 0 ||
                    td["commit"]["my_editor_commit"] > 0
                  ) {
                    //Revew Modal 1 Commited
                    $reviewModal +=
                      "<div class='greyAlert p15'>" + td["title"] + ":</div>";
                    $reviewModal +=
                      "<div class='iframe-document-wrap'>" +
                      $document_iFrame +
                      "</div>";

                    $reviewModal +=
                      "<div class='p15' style='background: #e2e2e2; position: relative; margin-top: 20px;'><div class='card-lt-wraps'><div class='card-lt'><div id='response-message' class='hide'> </div>";
                    $reviewModal +=
                      "<div class='card-form-lt'><div class='title-lt'>Feedback and Score Board</div>";
                    $reviewModal +=
                      "<form route='submit'><input type='hidden' id='reviewScriptID' value='" +
                      td["scriptID"] +
                      "'/><input type='hidden' id='reviewPhase' value='" +
                      td["review_phase"] +
                      "'/><div class='ResposeMessage'></div>";
                    $reviewModal +=
                      "<div class='form-group-lt'><textarea class='input-lt' id='reviewFeedback' placeholder='Feedback max " +
                      feedbackInputLimit +
                      " characters' rows='15' cols='50' maxlength='" +
                      feedbackInputLimit +
                      "'></textarea></div>";
                    if (
                      td["commit"]["my_reviewer_commit"] < 1 &&
                      td["commit"]["my_editor_commit"] > 0
                    ) {
                      $reviewModal +=
                        "<small class='hiddens'>Attach the edited paper (optional)</small><br/>";
                      $reviewModal +=
                        "<input type='file' class='input-lt' id='reviewFeedbackFile' placeholder='Upload File' accept='application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document' />";
                    }
                    $reviewModal +=
                      "<div class='form-group-lt chip-flex flex-center'><button class='button-lt-small blue' id='revise-file' data-scriptid='" +
                      td["scriptID"] +
                      "'><i class='fa fa-redo'> </i> Revise</button><button class='button-lt-small red' id='reject-file' data-scriptid='" +
                      td["scriptID"] +
                      "'><i class='fa fa-times'> </i> Decline</button><button class='button-lt-small green' id='accept-file' data-scriptid='" +
                      td["scriptID"] +
                      "'><i class='fa fa-check'> </i> Approve</button></div>";
                    $reviewModal += "</form></div></div></div>";
                  } else if (
                    td["commit"]["reviewer_commit_status"] > 0 &&
                    td["commit"]["editor_commit_status"] > 0
                  ) {
                    $reviewModal +=
                      "<div class='greyAlert p15'>" + td["title"] + ":</div>";
                    $reviewModal +=
                      "<div class='iframe-document-wrap'>" +
                      $document_iFrame +
                      "</div>";

                    $reviewModal +=
                      "<div class='p15' style='background: #e2e2e2; position: relative; margin-top: 20px;'><div class='card-lt-wraps'><div class='card-lt'><div id='response-message' class='hide'> </div>";
                    $reviewModal +=
                      "<div class='card-form-lt'><div class='title-lt'>Agree to evaluate this paper</div>";
                    $reviewModal +=
                      "<br/><div class='error'>You can't commit to this script anymore, because commit is closed!</div>";
                    $reviewModal += "</div>";
                    $reviewModal += "</div></div></div>";
                  } else {
                    let noEditorDisStat =
                      getState(this, "editor") < 1 ||
                      td["commit"]["editor_commit_status"] > 0
                        ? "disabled"
                        : "";
                    let noReviewerDisStat =
                      getState(this, "reviewer") < 1 ||
                      td["commit"]["reviewer_commit_status"] > 0 ||
                      getState(this, "editor") > 0
                        ? "disabled"
                        : "";

                    let commitBTN =
                      (getState(this, "editor") < 1 ||
                        td["commit"]["editor_commit_status"] > 0) &&
                      (getState(this, "reviewer") < 1 ||
                        td["commit"]["reviewer_commit_status"] > 0)
                        ? "disabled"
                        : "";

                    //Revew Modal 1 Not Commited
                    $reviewModal +=
                      "<div class='greyAlert p15'>" + td["title"] + ":</div>";
                    // $reviewModal +=
                    //   "<div class='iframe-document-wrap'>" +
                    //   $document_iFrame +
                    //   "</div>";

                    $reviewModal +=
                      "<div class='p15' style='background: #e2e2e2; position: relative; margin-top: 20px;'><div class='card-lt-wraps'><div class='card-lt'><div id='response-message' class='hide'> </div>";
                    $reviewModal +=
                      "<div class='card-form-lt'><div class='title-lt'>Agree to evaluate this paper</div>";
                    $reviewModal +=
                      "<form route='submit'><input type='hidden' id='reviewScriptID' value='" +
                      td["scriptID"] +
                      "'/><input type='hidden' id='reviewPhase' value='" +
                      td["review_phase"] +
                      "'/><div class='ResposeMessage'></div>";
                    $reviewModal +=
                      "<div class='form-group-lt'><ul class='input'>";
                    $reviewModal +=
                      "<li><input type='radio' id='commit_pledge' class='commit_pledge' name='commit_pledge' value='1' " +
                      noReviewerDisStat +
                      "><label for='comit'> I want to be a reviewer for this paper</label></input></li>";
                    $reviewModal +=
                      "<li><input type='radio' id='commit_pledge' class='commit_pledge' name='commit_pledge' value='0' " +
                      noEditorDisStat +
                      "><label for='comit'> I want to be the editor for this paper </label></input>";
                    $reviewModal += "</ul></div>";
                    $reviewModal +=
                      "<div style='background: #f2f2f2; padding: 6px; padding-top: 2px; padding-bottom: 5px;'>";
                    $reviewModal +=
                      "<div class='form-group-lt' style='text-align: center;'><input type='checkbox' id='commit_pledge_confirmation' class='commit_pledge_confirmation' name='commit_pledge_confirmation' value='1'> <label for='comit-accept'> I confirm that I am an expert in the research title of this paper/script ID: <b>" +
                      td["scriptID"] +
                      "</b>, and there is no conflict of interest.</label> </input></div>";
                    $reviewModal +=
                      "<div class='form-group-lt chip-flex flex-center'><button class='button-lt-small blue " +
                      commitBTN +
                      "' id='commit-script' data-scriptid='" +
                      td["scriptID"] +
                      "' " +
                      commitBTN +
                      "><i class='fa fa-check'> </i> Accept</button></div>";
                    $reviewModal += "</div>";
                    $reviewModal += "</form></div></div></div>";
                  }

                  //Review Modal 2
                  $reviewModal2 +=
                    "<div class='greyAlert p15'>" + td["title"] + ":</div>";
                  $reviewModal2 +=
                    "<div class='iframe-document-wrap'>" +
                    $document_iFrame2 +
                    "</div>";

                  $reviewModal2 +=
                    "<div class='p15' style='background: #e2e2e2; position: relative; margin-top: 20px;'><div class='card-lt-wraps'><div class='card-lt'><div id='response-message' class='hide'> </div>";
                  $reviewModal2 +=
                    "<div class='card-form-lt'><div class='title-lt'>Feedback and Score Board</div>";
                  $reviewModal2 +=
                    "<form route='submit'><input type='hidden' id='reviewScriptID' value='" +
                    td["scriptID"] +
                    "'/><input type='hidden' id='reviewPhase' value='" +
                    td["review_phase"] +
                    "'/><div class='ResposeMessage'></div>";
                  $reviewModal2 +=
                    "<div class='form-group-lt'><textarea class='input-lt' id='reviewFeedback' placeholder='Feedback max " +
                    feedbackInputLimit +
                    " characters' rows='15' cols='50' maxlength='" +
                    feedbackInputLimit +
                    "'></textarea></div>";
                  if (
                    td["commit"]["my_reviewer_commit"] < 1 &&
                    td["commit"]["my_editor_commit"] > 0
                  ) {
                    $reviewModal2 +=
                      "<small class='hiddens'>Attach the edited paper (optional)</small><br/>";
                    $reviewModal2 +=
                      "<input type='file' class='input-lt' id='reviewFeedbackFile' placeholder='Upload File' accept='application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document' />";
                  }
                  $reviewModal2 +=
                    "<div class='form-group-lt chip-flex flex-center'><button class='button-lt-small blue' id='revise-file' data-scriptid='" +
                    td["scriptID"] +
                    "'><i class='fa fa-redo'> </i> Revise</button><button class='button-lt-small red' id='reject-file' data-scriptid='" +
                    td["scriptID"] +
                    "'><i class='fa fa-times'> </i> Decline</button><button class='button-lt-small green' id='accept-file' data-scriptid='" +
                    td["scriptID"] +
                    "'><i class='fa fa-check'> </i> Approve</button></div>";
                  $reviewModal2 += "</form></div></div></div>";

                  //Review Modal 3
                  $reviewModal3 +=
                    "<div class='greyAlert p15'>" + td["title"] + ":</div>";
                  $reviewModal3 +=
                    "<div class='iframe-document-wrap'>" +
                    $document_iFrame3 +
                    "</div>";

                  $reviewModal3 +=
                    "<div class='p15' style='background: #e2e2e2; position: relative; margin-top: 20px;'><div class='card-lt-wraps'><div class='card-lt'><div id='response-message' class='hide'> </div>";
                  $reviewModal3 +=
                    "<div class='card-form-lt'><div class='title-lt'>Feedback and Score Board</div>";
                  $reviewModal3 +=
                    "<form route='submit'><input type='hidden' id='reviewScriptID' value='" +
                    td["scriptID"] +
                    "'/><input type='hidden' id='reviewPhase' value='" +
                    td["review_phase"] +
                    "'/><div class='ResposeMessage'></div>";
                  $reviewModal3 +=
                    "<div class='form-group-lt'><textarea class='input-lt' id='reviewFeedback' placeholder='Feedback max " +
                    feedbackInputLimit +
                    " characters' rows='15' cols='50' maxlength='" +
                    feedbackInputLimit +
                    "'></textarea></div>";
                  if (
                    td["commit"]["my_reviewer_commit"] < 1 &&
                    td["commit"]["my_editor_commit"] > 0
                  ) {
                    $reviewModal3 +=
                      "<small class='hiddens'>Attach the edited paper (optional)</small><br/>";
                    $reviewModal3 +=
                      "<input type='file' class='input-lt' id='reviewFeedbackFile' placeholder='Upload File' accept='application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document' />";
                  }
                  $reviewModal3 +=
                    "<div class='form-group-lt chip-flex flex-center'><button class='button-lt-small blue disabled' id='revise-file-none' data-scriptid='" +
                    td["scriptID"] +
                    "' disabled><i class='fa fa-redo'> </i> Revise</button><button class='button-lt-small red' id='reject-file' data-scriptid='" +
                    td["scriptID"] +
                    "'><i class='fa fa-times'> </i> Reject</button><button class='button-lt-small green' id='accept-file' data-scriptid='" +
                    td["scriptID"] +
                    "'><i class='fa fa-check'> </i> Accept</button></div>";
                  $reviewModal3 += "</form></div></div></div>";

                  //FeedBack Modal 1
                  $feedbackModal +=
                    "<div class='feedback-pane' style='overflow: auto; position: relative;'><div class='greyAlert p15'>" +
                    td["title"] +
                    ":</div>";
                  $feedbackModal +=
                    "<div class='p15' style='background: #e2e2e2; position: relative; margin-top: 20px;'><div class='card-lt-wraps'><div class='card-lt' style='position: relative;text-align: center; margin-bottom: 20px;transition: .3s; -webkit-transition: .3s; -moz-transition: .3s; -ms-transition: .3s; -o-transition: .3s; color: #0766C6; background-color: #fff; padding: 16px; border-radius: 6px; -webkit-border-radius: 6px; -moz-border-radius: 6px; -ms-border-radius: 6px; -o-border-radius: 6px; border: 1px; border-style: solid; border-color: rgba(213,210,229,.8);'>";
                  $feedbackModal +=
                    "<div class='card-form-lts'><div class='title-lt info-no' style='padding: 10px; font-family: 'Montserrat', sans-serif; background: #0766C6; color: #fff;font-size: 16px;margin-bottom: 40px; border: 1px solid; margin: 10px 0px; padding: 15px 10px 15px 50px; background-repeat: no-repeat; background-position: 10px center; border-radius: 5px; -webkit-border-radius: 5px; -moz-border-radius: 5px; -ms-border-radius: 5px; -o-border-radius: 5px;color: #00529B; background-color: #BDE5F8;'>Feedbacks for " +
                    td["scriptID"] +
                    "</div>";
                  $feedbackModal += $FeedBackList;
                  $feedbackModal +=
                    "</div></div></div></div></div><div class='p15' style='background: #e2e2e2; position: relative; margin-top: 20px;'><div class='no-print' style='padding-bottom: 8px; text-align:center;'><button class='go-full-screen-feedback'><i class='fa fa-arrows-alt' style='-ms-transform: rotate(45deg); transform: rotate(45deg);'> </i> Read on Fullscreen</button> <a data-scriptid='" +
                    td["scriptID"] +
                    "' data-fileuri='" +
                    td["feedback_file"]["f1"] +
                    "' class='print-feedback' href='javascript:void(0);'><button class='chip primaryX'><i class='fa fa-download'></i> Download PDF File</button></a></div></div>";

                  //Feedback Modal 2
                  $feedbackModal2 +=
                    "<div class='feedback-pane' style='overflow: auto; position: relative;'><div class='greyAlert p15'>" +
                    td["title"] +
                    ":</div>";
                  $feedbackModal2 +=
                    "<div class='p15' style='background: #e2e2e2; position: relative; margin-top: 20px;'><div class='card-lt-wraps'><div class='card-lt' style='position: relative;text-align: center; margin-bottom: 20px;transition: .3s; -webkit-transition: .3s; -moz-transition: .3s; -ms-transition: .3s; -o-transition: .3s; color: #0766C6; background-color: #fff; padding: 16px; border-radius: 6px; -webkit-border-radius: 6px; -moz-border-radius: 6px; -ms-border-radius: 6px; -o-border-radius: 6px; border: 1px; border-style: solid; border-color: rgba(213,210,229,.8);'>";
                  $feedbackModal2 +=
                    "<div class='card-form-lts'><div class='title-lt info-no' style='padding: 10px; font-family: 'Montserrat', sans-serif; background: #0766C6; color: #fff;font-size: 16px;margin-bottom: 40px; border: 1px solid; margin: 10px 0px; padding: 15px 10px 15px 50px; background-repeat: no-repeat; background-position: 10px center; border-radius: 5px; -webkit-border-radius: 5px; -moz-border-radius: 5px; -ms-border-radius: 5px; -o-border-radius: 5px;color: #00529B; background-color: #BDE5F8;'>Feedbacks for " +
                    td["scriptID"] +
                    "</div>";
                  $feedbackModal2 += $FeedBackList2;
                  $feedbackModal2 +=
                    "</div></div></div></div></div><div class='p15' style='background: #e2e2e2; position: relative; margin-top: 20px;'><div class='no-print' style='padding-bottom: 8px; text-align:center;'><button class='go-full-screen-feedback'><i class='fa fa-arrows-alt' style='-ms-transform: rotate(45deg); transform: rotate(45deg);'> </i> Read on Fullscreen</button> <a data-scriptid='" +
                    td["scriptID"] +
                    "' data-fileuri='" +
                    td["feedback_file"]["f2"] +
                    "' class='print-feedback' href='javascript:void(0);'><button class='chip primaryX'><i class='fa fa-download'></i> Download PDF File</button></a></div></div>";

                  //Feedback Modal 3
                  $feedbackModal3 +=
                    "<div class='feedback-pane' style='overflow: auto; position: relative;'><div class='greyAlert p15'>" +
                    td["title"] +
                    ":</div>";
                  $feedbackModal3 +=
                    "<div class='p15' style='background: #e2e2e2; position: relative; margin-top: 20px;'><div class='card-lt-wraps'><div class='card-lt' style='position: relative;text-align: center; margin-bottom: 20px;transition: .3s; -webkit-transition: .3s; -moz-transition: .3s; -ms-transition: .3s; -o-transition: .3s; color: #0766C6; background-color: #fff; padding: 16px; border-radius: 6px; -webkit-border-radius: 6px; -moz-border-radius: 6px; -ms-border-radius: 6px; -o-border-radius: 6px; border: 1px; border-style: solid; border-color: rgba(213,210,229,.8);'>";
                  $feedbackModal3 +=
                    "<div class='card-form-lts'><div class='title-lt info-no' style='padding: 10px; font-family: 'Montserrat', sans-serif; background: #0766C6; color: #fff;font-size: 16px;margin-bottom: 40px; border: 1px solid; margin: 10px 0px; padding: 15px 10px 15px 50px; background-repeat: no-repeat; background-position: 10px center; border-radius: 5px; -webkit-border-radius: 5px; -moz-border-radius: 5px; -ms-border-radius: 5px; -o-border-radius: 5px;color: #00529B; background-color: #BDE5F8;'>Feedbacks for " +
                    td["scriptID"] +
                    "</div>";
                  $feedbackModal3 += $FeedBackList3;
                  $feedbackModal3 +=
                    "</div></div></div></div></div><div class='p15' style='background: #e2e2e2; position: relative; margin-top: 20px;'><div class='no-print' style='padding-bottom: 8px; text-align:center;'><button class='go-full-screen-feedback'><i class='fa fa-arrows-alt' style='-ms-transform: rotate(45deg); transform: rotate(45deg);'> </i> Read on Fullscreen</button> <a data-scriptid='" +
                    td["scriptID"] +
                    "' data-fileuri='" +
                    td["feedback_file"]["f3"] +
                    "' class='print-feedback' href='javascript:void(0);'><button class='chip primaryX'><i class='fa fa-download'></i> Download PDF File</button></a></div></div>";

                  //(td['commit']['my_reviewer_commit'] > 0 || td['commit']['my_editor_commit'] > 0)
                  //(td['commit']['reviewer_commit_status'] > 0 && td['commit']['editor_commit_status'] > 0)

                  let R1 =
                    td["review_button"]["r1"] == "0" ||
                    getState(this, "reported") == "1"
                      ? "disabled"
                      : "";
                  let F1 = td["feedback_button"]["f1"] == "0" ? "disabled" : "";

                  let R2 =
                    td["review_button"]["r2"] == "0" ||
                    getState(this, "reported") == "1"
                      ? "disabled"
                      : "";
                  let F2 = td["feedback_button"]["f2"] == "0" ? "disabled" : "";

                  let R3 =
                    td["review_button"]["r3"] == "0" ||
                    getState(this, "reported") == "1"
                      ? "disabled"
                      : "";
                  let F3 = td["feedback_button"]["f3"] == "0" ? "disabled" : "";

                  if (
                    td["commit"]["reviewer_commit_status"] > 0 &&
                    td["commit"]["editor_commit_status"] > 0
                  ) {
                    if (
                      td["commit"]["my_reviewer_commit"] < 1 &&
                      td["commit"]["my_editor_commit"] < 1
                    ) {
                      R1 = "disabled";
                    }
                  } else if (
                    td["commit"]["reviewer_commit_status"] > 0 ||
                    td["commit"]["editor_commit_status"] > 0
                  ) {
                    if (
                      getState(this, "editor") < 1 &&
                      td["commit"]["reviewer_commit_status"] > 0 &&
                      td["commit"]["my_reviewer_commit"] < 1
                    ) {
                      R1 = "disabled";
                    } else if (
                      getState(this, "editor") > 0 &&
                      td["commit"]["editor_commit_status"] > 0 &&
                      td["commit"]["my_editor_commit"] < 1
                    ) {
                      R1 = "disabled";
                    }
                  }

                  if (
                    td["commit"]["my_reviewer_commit"] < 1 &&
                    td["commit"]["my_editor_commit"] < 1
                  ) {
                    R2 = "disabled";
                    R3 = "disabled";
                  }
                  //alert(td['review_button']['r1']+""+td['feedback_button']['f1']);
                  return (
                    <tr key={i}>
                      <td key={i}> {i + 1} </td>
                      <td>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <span style={{ marginRight: 12 }}>
                            {td["scriptID"]}
                          </span>
                          <span>
                            {getState(this, "editor") > 0 &&
                              td["commit"]["reviewer_commit_status"] < 1 && (
                                <button
                                  className="btn-sm btn-activeable chip primaryXD"
                                  onClick={() =>
                                    popModal("small", {
                                      title: td["scriptID"],
                                      body: $externalLinkModal,
                                    })
                                  }
                                  data-modalData={td["scriptID"]}
                                  title="Generate External Link"
                                >
                                  <i className="fa fa-link"> </i>
                                </button>
                              )}
                          </span>
                        </div>
                      </td>
                      <td hidden={hideRegion} className="center">
                        {td["target"]}
                      </td>
                      <td className="center nowrap">
                        <div
                          className={
                            td["commit"]["reviewer_commit_status"] < 1
                              ? "reviewer-commit-status active"
                              : "reviewer-commit-status"
                          }
                          title={
                            td["commit"]["reviewer_commit_status"] < 1
                              ? "Reviewer's needed"
                              : "No Reviewer's needed"
                          }
                        >
                          <span className="status-blink"></span>
                        </div>
                        <div
                          className={
                            td["commit"]["editor_commit_status"] < 1
                              ? "editor-commit-status active"
                              : "editor-commit-status"
                          }
                          title={
                            td["commit"]["editor_commit_status"] < 1
                              ? "Editor's needed"
                              : "No Editor's needed"
                          }
                        >
                          <span className="status-blink"></span>
                        </div>
                      </td>
                      <td className="chip-flex">
                        <button
                          className="btn-activeable chip primaryX"
                          onClick={() =>
                            popModal("large", {
                              title: td["scriptID"] + ": " + td["title"],
                              body: td["summary"],
                            })
                          }
                          data-modalData={td["summary"]}
                          title="Read"
                        >
                          <i className="fa fa-eye"></i> Read{" "}
                        </button>
                        {getState(this, "editor") > 0 ? (
                          <>
                            <button
                              className="btn-activeable chip dangerX"
                              disabled={getState(this, "reported") == "1"}
                              onClick={() =>
                                this.removeScriptEditor(td["scriptID"])
                              }
                              title="Delete/Remove"
                            >
                              <i className="fa fa-trash"> </i>
                            </button>
                          </>
                        ) : (
                          <></>
                        )}
                      </td>

                      <td>
                        <div className="chip-flex">
                          <button
                            disabled={R1}
                            className={
                              "btn-activeable chip primaryX pop-review-modal " +
                              R1
                            }
                            onClick={() =>
                              popModal("large", {
                                title: td["scriptID"],
                                body: $reviewModal,
                              })
                            }
                            data-modalData={td["scriptID"]}
                            title="Review"
                          >
                            {" "}
                            R{" "}
                          </button>
                          <button
                            disabled={F1}
                            className={
                              "btn-activeable chip primaryX pop-feedback-modal " +
                              F1
                            }
                            onClick={() =>
                              popModal("large", {
                                title: td["scriptID"],
                                body: $feedbackModal,
                              })
                            }
                            data-modalData={td["scriptID"]}
                            title="Feedback"
                          >
                            {" "}
                            F{" "}
                          </button>
                        </div>
                      </td>

                      <td>
                        <div className="chip-flex">
                          <button
                            disabled={R2}
                            className={
                              "btn-activeable chip primaryX pop-review-modal " +
                              R2
                            }
                            onClick={() =>
                              popModal("large", {
                                title: td["scriptID"],
                                body: $reviewModal2,
                              })
                            }
                            data-modalData={td["scriptID"]}
                            title="Review"
                          >
                            {" "}
                            R{" "}
                          </button>
                          <button
                            disabled={F2}
                            className={
                              "btn-activeable chip primaryX pop-feedback-modal " +
                              F2
                            }
                            onClick={() =>
                              popModal("large", {
                                title: td["scriptID"],
                                body: $feedbackModal2,
                              })
                            }
                            data-modalData={td["summary"]}
                            title="Feedback"
                          >
                            {" "}
                            F{" "}
                          </button>
                        </div>
                      </td>

                      <td>
                        <div className="chip-flex">
                          <button
                            disabled={R3}
                            className={
                              "btn-activeable chip primaryX pop-review-modal " +
                              R3
                            }
                            onClick={() =>
                              popModal("large", {
                                title: td["scriptID"],
                                body: $reviewModal3,
                              })
                            }
                            data-modalData={td["scriptID"]}
                            title="Review"
                          >
                            {" "}
                            R{" "}
                          </button>
                          <button
                            disabled={F3}
                            className={
                              "btn-activeable chip primaryX pop-feedback-modal " +
                              F3
                            }
                            onClick={() =>
                              popModal("large", {
                                title: td["scriptID"],
                                body: $feedbackModal3,
                              })
                            }
                            data-modalData={td["summary"]}
                            title="Feedback"
                          >
                            {" "}
                            F{" "}
                          </button>
                        </div>
                      </td>

                      <td className="nowrap" styles={{ maxWidth: "200px" }}>
                        {td["note"]}
                      </td>
                    </tr>
                  );
                })}
              </tbody>

              <tfoot>
                <tr>
                  <th>S/N</th>
                  {this.props.th?.map((th, i) => {
                    return (
                      <th
                        className={this.props.thclassX[i]}
                        key={i}
                        hidden={i == 1 && hideRegion}
                      >
                        {th}
                      </th>
                    );
                  })}
                </tr>
              </tfoot>
            </table>
          </div>

          <div className="card-lt">
            <div>
              Page: {getState(this, "page")} of {getState(this, "total_page")} ⟺
              ☆ Result: {parseInt(getState(this, "offset_set")) + parseInt(1)} -{" "}
              {Math.ceil(getState(this, "page") * limit_per_page) >=
              getState(this, "total_result")
                ? getState(this, "total_result")
                : Math.ceil(getState(this, "page") * limit_per_page)}{" "}
              of {getState(this, "total_result")}
            </div>

            <ReactPaginate
              previousLabel={"« Prev"}
              nextLabel={"Next »"}
              breakLabel={"..."}
              breakClassName={"break-me"}
              pageCount={getState(this, "total_page")}
              marginPagesDisplayed={2}
              pageRangeDisplayed={4}
              onPageChange={this.handlePageClick}
              containerClassName={"pagination"}
              activeClassName={"active"}
            />
          </div>
        </div>
      </>
    );
  }
}

export default DataTable;
